.error {
  color: var(--n-text-color-action-error);
}

.success {
  color: var(--n-text-color-action-success);
}
